import { CatalogPageProps } from "../../../../pages/catalog/[[...slug]]";

export const DEFAULT_PRECISION = 5;

export interface CatalogScreenProps {
    preloadedProps: CatalogPageProps;
}